(() => {
  "use strict";

  const page = document.querySelector(".fgp-page");

  if (!page) {
    return;
  }

  const modal = page.querySelector(
    "[data-fgp-modal]"
  );

  const openButtons = page.querySelectorAll(
    "[data-fgp-open]"
  );

  const closeButtons = page.querySelectorAll(
    "[data-fgp-close]"
  );

  const topButtons = page.querySelectorAll(
    "[data-fgp-top]"
  );

  const floatingTop = page.querySelector(
    "[data-fgp-floating-top]"
  );


  function openModal() {
    if (!modal) {
      return;
    }

    modal.hidden = false;

    document.documentElement.style.overflow =
      "hidden";

    const email = modal.querySelector(
      'input[type="email"]'
    );

    if (email) {
      window.setTimeout(
        () => email.focus(),
        50
      );
    }
  }


  function closeModal() {
    if (!modal) {
      return;
    }

    modal.hidden = true;

    document.documentElement.style.overflow =
      "";
  }


  openButtons.forEach((button) => {
    button.addEventListener(
      "click",
      openModal
    );
  });


  closeButtons.forEach((button) => {
    button.addEventListener(
      "click",
      closeModal
    );
  });


  topButtons.forEach((button) => {
    button.addEventListener(
      "click",
      () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    );
  });


  function updateFloatingTop() {
    if (!floatingTop) {
      return;
    }

    const threshold = Math.max(
      500,
      window.innerHeight * 0.65
    );

    floatingTop.classList.toggle(
      "is-visible",
      window.scrollY > threshold
    );
  }


  window.addEventListener(
    "scroll",
    updateFloatingTop,
    {
      passive: true,
    }
  );


  window.addEventListener(
    "resize",
    updateFloatingTop
  );


  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    }
  );


  updateFloatingTop();
})();
